(function () {
  function initFaqSection(root) {
    if (!root || root.dataset.faqInitialized === 'true') {
      return;
    }

    const topicButtons = Array.from(root.querySelectorAll('[data-faq-topic]'));
    const questionGroups = Array.from(root.querySelectorAll('.collection-faq__question-group[data-topic-key]'));
    const answerTarget = root.querySelector('[data-faq-answer]');

    if (!topicButtons.length || !questionGroups.length) {
      root.dataset.faqInitialized = 'true';
      return;
    }

    function getVisibleGroup() {
      return questionGroups.find((group) => !group.hidden) || null;
    }

    function setAnswerFromQuestionButton(button) {
      if (!button) {
        if (answerTarget) {
          answerTarget.innerHTML = '';
        }
        return;
      }

      const item = button.closest('.collection-faq__question-item');
      if (!item) {
        return;
      }

      const source = item.querySelector('[data-faq-answer-source]');
      const answerHtml = source ? source.innerHTML.trim() : '';

      if (answerTarget) {
        answerTarget.innerHTML = answerHtml;
      }

      const visibleGroup = getVisibleGroup();
      if (visibleGroup) {
        visibleGroup.querySelectorAll('[data-faq-answer-inline]').forEach((node) => {
          node.hidden = true;
        });
      }

      const inlineAnswer = item.querySelector('[data-faq-answer-inline]');
      if (inlineAnswer) {
        inlineAnswer.hidden = false;
      }
    }

    function activateQuestion(button) {
      const group = button ? button.closest('.collection-faq__question-group') : null;
      if (!group) {
        return;
      }

      group.querySelectorAll('[data-faq-question]').forEach((btn) => {
        const isActive = btn === button;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      setAnswerFromQuestionButton(button);
    }

    function activateTopic(topicKey) {
      if (!topicKey) {
        return;
      }

      topicButtons.forEach((btn) => {
        const isActive = btn.dataset.topicKey === topicKey;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      questionGroups.forEach((group) => {
        const isActive = group.dataset.topicKey === topicKey;
        group.hidden = !isActive;
      });

      const activeGroup = questionGroups.find((group) => group.dataset.topicKey === topicKey && !group.hidden);
      if (!activeGroup) {
        if (answerTarget) {
          answerTarget.innerHTML = '';
        }
        return;
      }

      const firstQuestion = activeGroup.querySelector('[data-faq-question]');
      if (firstQuestion) {
        activateQuestion(firstQuestion);
      } else if (answerTarget) {
        answerTarget.innerHTML = '';
      }
    }

    topicButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        activateTopic(btn.dataset.topicKey || '');
      });
    });

    questionGroups.forEach((group) => {
      group.addEventListener('click', function (event) {
        const button = event.target.closest('[data-faq-question]');
        if (!button || !group.contains(button)) {
          return;
        }
        activateQuestion(button);
      });
    });

    const initialTopicKey = root.dataset.defaultTopicKey || '';
    const firstTopicButton = topicButtons[0];
    activateTopic(initialTopicKey || (firstTopicButton ? firstTopicButton.dataset.topicKey : ''));

    root.dataset.faqInitialized = 'true';
  }

  function initAllFaqSections(scope) {
    const context = scope || document;
    context.querySelectorAll('[data-collection-faq]').forEach((section) => {
      initFaqSection(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllFaqSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllFaqSections(event.target);
  });
})();
